// extracted by mini-css-extract-plugin
export default {"container":"policy-list-container_container__5TUem"};